import axios from 'axios';

export const withAuthorizationInterceptor = (authService: any) => {
    
    const interceptor = axios.interceptors.request.use(request => {
        if (authService.isAuthenticated()) {
            request.headers.setAuthorization(`Bearer ${authService.getAccessToken()}`);
        }
        return request;
    });

    return () => axios.interceptors.request.eject(interceptor);
};
